import { z } from 'zod';
import { newCampaignSearchSchema as wizardSearchSchema } from '@discovr/ui';

// The router parses a search value as JSON when it can, so `?add=12345` arrives as a number: read it back as text.
const text = z.preprocess((v) => (typeof v === 'number' ? String(v) : v), z.string().optional()).catch(undefined);

// The wizard's `?step=` plus the Add to campaign → New campaign handover (the Competitors tab). Brand-only: the
// admin route keeps the wizard's own schema, so `?add=` never reaches it.
export const newCampaignSearchSchema = wizardSearchSchema.extend({
  // Comma-separated Instagram handles to add once the campaign is created, and the comparison they came from.
  // URL only, never in the persisted draft.
  add: text,
  comparison: text,
});

export type NewCampaignSearch = z.infer<typeof newCampaignSearchSchema>;

/** `?add=` as handles: trimmed, no leading @, lowercase, no empties or repeats. */
export const handlesToAdd = (add: string | undefined): string[] =>
  [...new Set((add ?? '').split(',').map((h) => h.trim().replace(/^@+/, '').toLowerCase()).filter(Boolean))];
